import React from "react";

const TextRenderer = ({
  object,
  dataJson,
  styleJson,
  commonStyle,
  handleMouseDown,
  renderSelectionHandles,
}) => {
  const handleLocalMouseDown = (e) => {
    e.stopPropagation();
    handleMouseDown?.(e);
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={handleLocalMouseDown}
      style={{
        position: "absolute",
        ...commonStyle,
        fontSize: styleJson.fontSize || 16,
        fontWeight: styleJson.fontWeight || "normal",
        fontFamily: styleJson.fontFamily || "Arial",
        display: object.visible === false ? "none" : "flex",
        alignItems: "center",
        justifyContent:
          styleJson.textAlign === "center"
            ? "center"
            : styleJson.textAlign === "right"
            ? "flex-end"
            : "flex-start",
        padding: "4px 6px",
        whiteSpace: "nowrap",
        userSelect: "none",
        outline: renderSelectionHandles() ? "2px solid #2563eb" : "none",
        outlineOffset: renderSelectionHandles() ? "2px" : "0",
      }}
    >
      <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
        {dataJson.text || ""}
      </div>
      {renderSelectionHandles()}
    </div>
  );
};

export default TextRenderer;